import { render } from "./AposImageControlDialog.vue?vue&type=template&id=0e183567&scoped=true"
import script from "./AposImageControlDialog.vue?vue&type=script&lang=js"
export * from "./AposImageControlDialog.vue?vue&type=script&lang=js"

import "./AposImageControlDialog.vue?vue&type=style&index=0&id=0e183567&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e183567"],['__file',"rich-text-widget/ui/apos/components/AposImageControlDialog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0e183567"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0e183567', __exports__)) {
    api.reload('0e183567', __exports__)
  }
  
  module.hot.accept("./AposImageControlDialog.vue?vue&type=template&id=0e183567&scoped=true", () => {
    api.rerender('0e183567', render)
  })

}


export default __exports__